import { createAction } from "@reduxjs/toolkit";
import {
  socketConnectedActionType,
  startSocketActionType,
  stopSocketActionType,
  setSocketActionType,
} from "./actionTypes";

export const startSocket = createAction(startSocketActionType, () => ({}));

export const stopSocket = createAction(stopSocketActionType, () => ({}));
export const socketConnected = createAction(
  socketConnectedActionType,
  () => ({}),
);
export const setSocket = createAction(setSocketActionType, (payload) => ({
  payload,
}));
